import React from "react";
import css from "./style.scss";
import { connect } from "react-redux";
import { FullPage } from "components/container";
import api from "./api";
import permissions from "shared/permissions";
import store from "utils/store";
import { push } from "react-router-redux";
import AdBox from "components/adBox";
import Button from "components/shared/button";
import EmptyPage from "./empty";
import cn from "classnames";

class Account extends React.PureComponent {
  onClick() {
    store.dispatch(push("/a/" + this.props.id));
  }
  render() {
    let style = { backgroundImage: "url(" + this.props.picture + ")" };
    return (
      <div
        className={cn(css.page, this.props.paused ? css.paused : "")}
        onClick={this.onClick.bind(this)}
        style={style}
      >
        <div className={css.page_info}>
          <div className={css.page_title}>{this.props.name}</div>
          <div className={css.page_user}>@{this.props.info.username}</div>
        </div>
        {this.props.paused_at && <div className={css.paused}></div>}
      </div>
    );
  }
}

class AccountsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
    this.handleNewAccountClick = this.handleNewAccountClick.bind(this);
  }
  componentDidMount() {
    api.getAccounts().then(() => {
      this.setState({ loading: false });
    });
  }
  handleNewAccountClick() {
    if (
      permissions.createAccount(
        this.props.user.subscription,
        this.props.accounts.filter(a => a.paused_at === undefined).length
      )
    ) {
      store.dispatch(push("/accounts/new"));
    } else {
      if (!this.props.user.subscription.active) {
        store.dispatch({ type: "OPEN_PREMIUM_MODAL" });
      } else {
        store.dispatch({
          type: "ADD_TOAST",
          message: "You reached your accounts limit."
        });
      }
    }
  }
  render() {
    const pausedAccounts = this.props.accounts.filter(a => a.paused_at);
    const activeAccounts = this.props.accounts.filter(
      a => a.paused_at === undefined
    );
    return (
      <FullPage withContainer>
        {this.props.accounts.length > 0 && (
          <div className={css.titleContainer}>
            <h3>Your accounts</h3>
            <Button
              className={css.newAccountButton}
              onClick={this.handleNewAccountClick}
              primary
            >
              Add new Account
            </Button>
          </div>
        )}
        <div>
          {this.props.accounts.length > 0 && (
            <div className={css.container}>
              <div className={css.main_content}>
                <div className={css.accounts_container}>
                  <div className={css.accounts}>
                    {activeAccounts.map(account => (
                      <Account key={account.id} {...account} />
                    ))}
                  </div>
                  {!this.props.user.subscription.active && (
                    <div className={css.adContent}>
                      <AdBox />
                    </div>
                  )}
                  {pausedAccounts.length > 0 && (
                    <div className={css.accounts_paused}>
                      <h4>Paused Accounts</h4>
                      <div className={css.accounts}>
                        {pausedAccounts.map(account => (
                          <Account paused key={account.id} {...account} />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {this.props.accounts.length === 0 && (
            <EmptyPage
              avatar={this.props.user.avatar}
              name={this.props.user.firstName}
            />
          )}
        </div>
      </FullPage>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    user: state.user.userData,
    accounts: Object.keys(state.accounts).map(a => state.accounts[a])
  };
};

export default connect(mapStateToProps)(AccountsPage);



// WEBPACK FOOTER //
// ./src/components/accounts_page/index.js